module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-table', {
    staticStyle: {
      "border": "1px solid #e1e8e9"
    },
    attrs: {
      "showCheckbox": false
    }
  }, [_c('mu-thead', [_c('mu-tr', [_c('mu-th', {
    staticClass: "pointer"
  }, [_vm._v("Client")]), _vm._v(" "), _c('mu-th', {
    staticClass: "pointer"
  }, [_vm._v("Scan(s)")]), _vm._v(" "), _c('mu-th', {
    staticClass: "medium-hide"
  }, [_vm._v("CodeBarre")]), _vm._v(" "), _c('mu-th', [_vm._v("Manquants")])], 1)], 1), _vm._v(" "), _c('mu-tbody', _vm._l((_vm.cbtable), function(item, index) {
    return _c('mu-tr', {
      key: item.fk_soc,
      staticClass: "pointer",
      nativeOn: {
        "click": function($event) {
          _vm.trRoute(index)
        }
      }
    }, [_c('mu-td', [_vm._v(_vm._s(item.cus_name))]), _vm._v(" "), _c('mu-td', [_vm._v(_vm._s(item.barcode_scan))]), _vm._v(" "), _c('mu-td', {
      staticClass: "medium-hide"
    }, [_vm._v(_vm._s(item.barcode_count))]), _vm._v(" "), _c('mu-td', [_vm._v(_vm._s(item.barcode_count - item.barcode_scan))])], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-595a105d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Scan_customer.vue
// module id = 443
// module chunks = 1